import { For, Show } from 'solid-js';
import type { ProductSupplementsProps } from './product-supplements-types';
import type { DocumentType } from '../product-types';
import { FileDownloadIcon } from '../../icons-library/file-download';
import { removeTrailingSlash } from '../../../tools/remove-trailing-slash';
import { Link } from '../../../ui-components/link/link';
import removeAmpersand from '../../../tools/remove-ampersand';

export const ProductSupplements = (props: ProductSupplementsProps) => {
    return (
        <For each={props.documents}>
            {(document: DocumentType) => (
                <Show when={document?.file?.url}>
                    <div class="w-fit flex items-center gap-cvi-6 normal-case px-cvi-4 text-cvi-fg-default">
                        <FileDownloadIcon fill='currentColor' size='lg' />
                        <Link
                            label={removeAmpersand(document.file?.title || document.file?.name || document.file?.filename)}
                            url={removeTrailingSlash(document.file.url)}
                            opensInNewTab={true}
                        />
                    </div>
                </Show>
            )}
        </For>
    );
};
